import { render, staticRenderFns } from "./FeedbackStatus.vue?vue&type=template&id=54ac1fe6&scoped=true&"
import script from "./FeedbackStatus.vue?vue&type=script&lang=js&"
export * from "./FeedbackStatus.vue?vue&type=script&lang=js&"
import style0 from "./FeedbackStatus.vue?vue&type=style&index=0&id=54ac1fe6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ac1fe6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VCard,VCol,VIcon,VListItem,VListItemContent,VListItemIcon,VListItemTitle,VRow,VToolbar,VToolbarTitle})
